module.exports = __webpack_public_path__ + "img/huiyuan1.e0cab2a4.png";